import { setting } from "./setting";
import { addClass, removeClass } from "fire-wind-water/dom";
import { $dom } from "../common/dom";

declare const $cz: any;

$cz.setup("afterLoad", () => {
  if (setting.createComponent) {
    const d = document.getElementById(
      `${setting.createComponent.type}_${setting.createComponent.id}`
    );
    if (d) {
      let t = d.offsetTop;
      const it =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      if (t > it) {
        t = it;
      }
      $dom.fanhui(t);
      setting.createComponent = null;
      addClass(d, "active");
      setTimeout(() => {
        removeClass(d, "active");
      }, 5000);
    }
  }
});
